<template>
  <div>
    <div v-if="fooldalData">
      <div class="relative" v-if="vezerhir.length > 0">
        <swiper-container class="mb-5" :options="vezerhirSwiperOptions">
          <div class="swiper-slide" v-for="hir in vezerhir" :key="hir.Id">
            <v-card
              class="vezerhir mb-5"
              :to="{
                name: 'Hir',
                params: {
                  id: hir.Azonosito,
                },
              }"
            >
              <v-img height="450px" :src="hir.Kep + '?h=450'">
                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                  <!-- <v-toolbar-title class="title white--text pl-0">
              Vezérhír
            </v-toolbar-title> -->
                  <v-spacer></v-spacer>
                  <k-fontos-hir-icon
                    class="mr-0 mt-5"
                    color="primary"
                    :hir="hir"
                  ></k-fontos-hir-icon>
                </v-app-bar>
                <div class="vezerhir-bottom">
                  <!-- <v-chip pill small class="white--text mb-2">1/3</v-chip> -->
                  <div class="vezerhir-bottom-bg">
                    <p
                      class="white--text mb-2"
                      v-html="hir.Kategoriak.map(m => m.Nev).join(', ')"
                    ></p>
                    <h3 class="white--text mb-2">
                      {{ hir.Cim }}
                    </h3>
                    <p class="white--text hirismerteto">
                      {{ vezerhir.Ismerteto }}
                    </p>
                    <div class="d-inline-flex">
                      <v-img
                        :src="
                          hir.Szerzo.Kep
                            ? hir.Szerzo.Kep + '?w=32&h=32'
                            : $placeholderImage
                        "
                        height="32px"
                        max-height="32px"
                        width="32px"
                        max-width="32px"
                        class="rounded"
                      >
                      </v-img>
                      <p class="mb-0 white--text d-flex align-center">
                        <span class="dot-separator white mx-2"></span>
                        {{ hir.Szerzo.Nev }}
                        <span class="dot-separator white mx-2"></span>
                        <k-live-timestamp
                          :value="hir.MegjelenesDatuma"
                        ></k-live-timestamp>
                      </p>
                    </div>
                  </div>
                </div>
              </v-img>
            </v-card>
          </div>
        </swiper-container>
        <div class="swiper-pagination"></div>
      </div>
      <div v-if="fooldalData.topHirek.length > 0">
        <div class="flex-center-between mb-3">
          <h3 class="primary--text">
            {{ nyelvesites['legfrissebbek_text'] }}
          </h3>
          <router-link
            class="grey--text text--darken-2"
            :to="{ name: 'Hirek' }"
          >
            {{ nyelvesites['tovabbi_text'] }} cikkek >
          </router-link>
        </div>
        <swiper-container class="mb-5" :options="swiperOptions">
          <div
            class="swiper-slide"
            v-for="hir in fooldalData.topHirek"
            :key="hir.Id"
          >
            <v-card
              class="mb-3 hir"
              :to="{
                name: 'Hir',
                params: {
                  id: hir.Azonosito,
                },
              }"
            >
              <v-img
                height="150px"
                :src="hir.Kep ? hir.Kep + '?h=150' : $placeholderImage"
              >
                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                  <v-spacer></v-spacer>

                  <k-fontos-hir-icon
                    small
                    color="primary"
                    :hir="hir"
                  ></k-fontos-hir-icon>
                </v-app-bar>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
            <h3 class="primary--text mb-1 text-truncate-hir">
              <span class="line-clamp">{{ hir.Cim }}</span>
            </h3>
            <p
              class="grey--text text--darken-2 d-flex align-center flex-wrap mb-0"
            >
              {{ hir.Szerzo.Nev }}
              <span class="dot-separator grey darken-2 mx-2"></span>
              {{ hir.MegjelenesDatuma | toShortDate }}
            </p>
          </div>
        </swiper-container>
      </div>
      <div v-if="isEsemenyNaptarVisible" class="esemenynaptar">
        <div class="mb-3">
          <h3 class="primary--text">Eseménynaptár</h3>
        </div>
        <k-event-calendar class="mb-5"></k-event-calendar>
      </div>
      <div
        class="kategoriak"
        v-for="kiemeltKategoria in kiemeltKategoriak"
        :key="kiemeltKategoria.Id"
      >
        <div class="flex-center-between mb-3">
          <h3 class="primary--text" v-html="kiemeltKategoria.Nev"></h3>
          <router-link
            class="grey--text text--darken-2"
            :to="{
              name: 'KiemeltKategoria',
              params: { id: kiemeltKategoria.Id },
            }"
          >
            {{ nyelvesites['tovabbi_text'] }} {{ kiemeltKategoria.Nev }} >
          </router-link>
        </div>
        <swiper-container class="mb-5" :options="swiperOptions">
          <div
            class="swiper-slide"
            v-for="kategoria in kiemeltKategoria.Kategoria"
            :key="kategoria.Id"
          >
            <v-card
              class="mb-3"
              :to="{
                name: 'KiemeltKategoria',
                params: { id: kiemeltKategoria.Id },
                query: { alKategoriaId: kategoria.Id },
              }"
            >
              <v-img
                height="85px"
                width="175px"
                :src="
                  kategoria.Kep
                    ? kategoria.Kep + '?w=175&h=85'
                    : $placeholderImage
                "
              >
                <h4 class="white--text text-center" v-html="kategoria.Nev"></h4>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </div>
        </swiper-container>
      </div>
      <div
        v-if="
          aktivSzerzokSorrendezve.length > 0 && aktualisProjekt.AktivSzerzokFl
        "
      >
        <div class="flex-center-between mb-3">
          <h3 class="primary--text">
            {{ nyelvesites['aktiv_szerzok_text'] }}
          </h3>
          <router-link
            class="grey--text text--darken-2"
            :to="{ name: 'Szerzok' }"
          >
            {{ nyelvesites['tovabbi_text'] }} szerzők >
          </router-link>
        </div>
        <swiper-container
          class="mb-5 szerzok-swiper"
          :options="szerzokSwiperOptions"
        >
          <div
            class="swiper-slide d-flex flex-column align-center"
            v-for="szerzo in aktivSzerzokSorrendezve"
            :key="szerzo.Id"
          >
            <router-link
              :to="{ name: 'Szerzok', params: { id: szerzo.Id } }"
              class="align-center d-flex flex-column"
            >
              <v-img
                height="64px"
                width="64px"
                :src="szerzo.Kep ? szerzo.Kep + '?h=64' : $placeholderImage"
                class="mb-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <h3 class="primary--text text-center">{{ szerzo.Nev }}</h3>
            </router-link>
          </div>
        </swiper-container>
      </div>
      <div
        v-if="
          fooldalData.nepszeruHirek.length > 0 &&
            aktualisProjekt.SokanOlvastakFl
        "
      >
        <div class="flex-center-between mb-3">
          <h3 class="primary--text">
            {{ nyelvesites['nepszeru_cikkek_text'] }}
          </h3>
          <router-link
            class="grey--text text--darken-2"
            :to="{ name: 'NepszeruHirek' }"
          >
            {{ nyelvesites['tovabbi_text'] }} népszerű cikkek >
          </router-link>
        </div>
        <swiper-container class="mb-5" :options="nepszeruHirekSwiperOptions">
          <div
            class="swiper-slide"
            v-for="nepszeruHir in fooldalData.nepszeruHirek"
            :key="nepszeruHir.Id"
          >
            <v-card
              class="mb-3 hir"
              :to="{
                name: 'Hir',
                params: {
                  id: nepszeruHir.Azonosito,
                },
              }"
            >
              <v-img
                height="100px"
                :src="
                  nepszeruHir.Kep
                    ? nepszeruHir.Kep + '?h=100'
                    : $placeholderImage
                "
              >
                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                  <v-spacer></v-spacer>
                  <k-fontos-hir-icon small color="primary" :hir="nepszeruHir">
                  </k-fontos-hir-icon>
                </v-app-bar>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0"> </v-row>
                </template>
              </v-img>
            </v-card>
            <h3 class="primary--text text-capitalize text-truncate-hir">
              <span class="line-clamp">{{ nepszeruHir.Cim }}</span>
            </h3>
            <p class="grey--text text--darken-2 d-flex align-center mb-0">
              {{ nepszeruHir.Szerzo.Nev }}
              <span class="dot-separator grey darken-2 mx-2"></span>
              {{ nepszeruHir.MegjelenesDatuma | toShortDate }}
            </p>
          </div>
        </swiper-container>
      </div>
      <div
        v-if="fooldalData.youtubeVideok.length > 0 && aktualisProjekt.YoutubeFl"
        class="yt-videok"
      >
        <div class="flex-center-between mb-3">
          <h3 class="primary--text">
            {{ nyelvesites['legfrissebb_videok_text'] }}
          </h3>
          <router-link
            class="grey--text text--darken-2"
            :to="{ name: 'YoutubeVideok' }"
          >
            {{ nyelvesites['tovabbi_text'] }} {{ nyelvesites['videok_text'] }} >
          </router-link>
        </div>
        <swiper-container class="mb-5" :options="youtubeVideokSwiperOptions">
          <div
            class="swiper-slide"
            v-for="video in fooldalData.youtubeVideok"
            :key="video.Id"
          >
            <v-card class="mb-3" @click="OpenYoutubeVideoModal(video)">
              <v-img :src="video.Thumbnail || $placeholderImage">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div class="yt-stats">
                <div class="views">
                  <i class="fas fa-eye mr-1"></i>
                  {{ video.StatisticsViews }}
                </div>
                <div class="rating">
                  <i class="fas fa-star mr-1"></i>
                  {{ video.StarRating.Count }}
                </div>
              </div>
            </v-card>
            <h3 class="primary--text mb-1 text-truncate-hir">
              <span class="line-clamp">{{ video.Title }}</span>
            </h3>
            <p
              class="grey--text text--darken-2 d-flex align-center flex-wrap mb-0"
            >
              {{ video.Published | toShortDate }}
            </p>
          </div>
        </swiper-container>
      </div>
    </div>
    <div v-else>
      <k-fooldal-skeleton></k-fooldal-skeleton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../../../functions/AppFunctions';
import { eventBus } from '../../../main';
import { AppStoreTypes } from '../../../store/modules/app';
import { modalHandler } from '../../../utils/vue/modalHandler';
import { useWindow } from '../../../utils/vue/useWindow';

export default {
  name: 'fooldal-mobile-layout',
  data() {
    return {
      vezerhirSwiperOptions: {
        spaceBetween: 20,
        speed: 400,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          bulletElement: 'span',
        },
      },
      szerzokSwiperOptions: {
        spaceBetween: 20,
        speed: 400,
        freeMode: true,
        freeModeSticky: true,
        slidesPerView: 'auto',
        watchOverflow: true,
      },
      adatokBetoltese: false,
    };
  },
  setup() {
    let { windowSize } = useWindow();
    return { windowSize };
  },
  created() {
    eventBus.$on('after-login', this.GetFooldalAdatok);
  },
  beforeDestroy() {
    eventBus.$off('after-login', this.GetFooldalAdatok);
  },
  mounted() {
    this.GetFooldalAdatok();
  },
  activated() {
    this.GetFooldalAdatok();
  },
  methods: {
    OpenYoutubeVideoModal(video) {
      modalHandler.OpenModal('youtube-video-modal', video);
    },
    async GetFooldalAdatok() {
      if (this.adatokBetoltese) {
        return;
      }
      this.adatokBetoltese = true;
      try {
        await AppFunctions.GetFooldalAdatok();
      } catch (error) {
        console.log(error);
      }
      this.adatokBetoltese = false;
    },
  },
  computed: {
    ...mapGetters({
      fooldalData: AppStoreTypes.fooldalData.get,
      hirKategoriak: AppStoreTypes.hirKategoriak.getAll,
      user: AppStoreTypes.user.get,
    }),
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
    vezerhir() {
      console.log(this.fooldalData);
      return this.fooldalData?.vezerHir;
    },
    getAlkategoriak() {
      return AppFunctions.GetAlkategoriakFromKategoriak(this.hirKategoriak);
    },
    aktivSzerzokSorrendezve() {
      return AppFunctions.SortSzerzok(this.fooldalData.aktivSzerzok, this.user);
    },
    defaultSwiperSlidesBasedOnWidth() {
      let windowWidth = this.windowSize.width;
      return Math.floor(windowWidth / 185) + 0.8;
    },
    nepszeruHirekSwiperSlidesBasedOnWidth() {
      let windowWidth = this.windowSize.width;
      return Math.floor(windowWidth / 185) + 0.2;
    },
    youtubeVideokSwiperSlidesBasedOnWidth() {
      let windowWidth = this.windowSize.width;
      return Math.floor(windowWidth / 350) + 0.2;
    },
    swiperOptions() {
      return {
        spaceBetween: 20,
        speed: 400,
        freeMode: true,
        freeModeSticky: true,
        slidesPerView: this.defaultSwiperSlidesBasedOnWidth,
        watchOverflow: true,
      };
    },
    nepszeruHirekSwiperOptions() {
      return {
        spaceBetween: 20,
        speed: 400,
        freeMode: true,
        freeModeSticky: true,
        slidesPerView: this.nepszeruHirekSwiperSlidesBasedOnWidth,
        watchOverflow: true,
      };
    },
    youtubeVideokSwiperOptions() {
      return {
        spaceBetween: 20,
        speed: 400,
        freeMode: true,
        freeModeSticky: true,
        slidesPerView: this.youtubeVideokSwiperSlidesBasedOnWidth,
        watchOverflow: true,
      };
    },
    kiemeltKategoriak() {
      return this.hirKategoriak.filter(f => f.Kiemelt);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    getMiniVezerhirek() {
      return this.fooldalData?.vezerHir.slice(1, 5);
    },
    isEsemenyNaptarVisible() {
      return this.aktualisProjekt.EsemenynaptarFl;
    },
  },
  watch: {},
  components: {},
};
</script>
